module.exports = __webpack_public_path__ + "static/logo-fbb1bbbbae30f14d67ea0fdc0278021f.png";